// Actions for the inventory state
import { ProductCostSettings } from '../../models/inventory.model';
import { MetricUpdateResult } from './inventory.model';

export class GetInventorySummary {
  static readonly type = '[Inventory] Get Summary';
  constructor(public payload?: { search?: string; showActiveOnly?: boolean }) {}
}

export class GetInventoryProducts {
  static readonly type = '[Inventory] Get Products';
  constructor(
    public payload?: {
      page?: number;
      limit?: number;
      search?: string;
      sortBy?: string;
      sortDir?: 'asc' | 'desc';
      showActiveOnly?: boolean;
      showWithoutCogs?: boolean;
    }
  ) {}
}

export class UpdateProductCostSettings {
  static readonly type = '[Inventory] Update Product Cost Settings';
  constructor(public payload: ProductCostSettings) {}
}

export class UpdateProductCost {
  static readonly type = '[Inventory] Update Product Cost';
  constructor(
    public payload: {
      productId: string;
      skuId?: string;
      unitCog?: number | null;
      fbsUnitStorageFee?: number | null;
      fbsUnitFulfillmentFee?: number | null;
      fbsManualShippingCostPerUnit?: number | null;
    }
  ) {}
}

export class SyncInventory {
  static readonly type = '[Inventory] Sync Inventory';
}

export class UpdateInventoryMetricsVisibility {
  static readonly type = '[Inventory] Update Inventory Metrics Visibility';
  constructor(public payload: { metrics: { metricId: string; visible: boolean }[] }) {}
}

export class UpdateInventoryMetricsVisibilitySuccess {
  static readonly type = '[Inventory] Update Metrics Visibility Success';
  constructor(public results: MetricUpdateResult[]) {}
}

export class UpdateInventoryMetricsVisibilityFailure {
  static readonly type = '[Inventory] Update Inventory Metrics Visibility Failure';
  constructor(public error: any) {}
}

// Add these actions to your existing inventory.actions.ts
export class FetchFbtWarehouses {
  static readonly type = '[Inventory] Fetch FBT Warehouses';
  constructor(public payload: { shopId: string }) {}
}

export class FetchFbtWarehousesSuccess {
  static readonly type = '[Inventory] Fetch FBT Warehouses Success';
  constructor(public payload: any) {}
}

export class FetchFbtWarehousesFailure {
  static readonly type = '[Inventory] Fetch FBT Warehouses Failure';
  constructor(public error: any) {}
}

export class UpdateProductCostSuccess {
  static readonly type = '[Inventory] Update Product Cost Success';
  constructor(public payload: { productId: string; skuId?: string; updatedData: any }) {}
}

export class RefreshProductData {
  static readonly type = '[Inventory] Refresh Product Data';
  constructor(public payload: { productId: string; skuId?: string }) {}
}
